module.exports = __webpack_public_path__ + "img/rhb-bank-img.74200600.png";